<div class='flex justify-content-start mt-3'>
    <button
        title="Select All"
        pButton
        pRipple
        text
        severity="secondary"
        type="button"
        (click)="selectedEmployees = items"
        label="Select All"
        class="mr-3"
    ></button>
    <button
        title="Select None"
        pButton
        pRipple
        text
        severity="secondary"
        type="button"
        (click)="selectedEmployees = []"
        label="Select None"
    ></button>
</div>
<p>
    <p-tree
        [filter]="true"
        filterMode="strict"
        filterPlaceholder="Search for user(s)"
        #employeeTree
        [value]="items"
        selectionMode="checkbox"
        [(selection)]="selectedEmployees"
        scrollHeight="flex"
    ></p-tree>
</p>
<div class="flex justify-content-start">
    <button
        [disabled]="(!(selectedEmployees?.length ?? 0 > 0)) || resend"
        title="Send Expenses"
        pButton
        pRipple
        severity="primary"
        icon="pi pi-send"
        type="button"
        (click)="onSendPurchases(employeeTree.selection)"
        label="Send Expenses"
    ></button>
    <button
        [disabled]="(!(selectedEmployees?.length ?? 0 > 0)) || !resend"
        title="Resend Expenses"
        pButton
        pRipple
        severity="primary"
        icon="pi pi-replay"
        type="button"
        (click)="onSendPurchases(employeeTree.selection)"
        label="Resend"
        class="mx-3"
    ></button>
    <div class="flex items-center align-items-center">
        <p-checkbox
            checked="false"
            #sendReceiptImages
            binary="true"
        ></p-checkbox>
        <label class="ml-2 mt-2" for="sendReceiptImages">Send Receipts</label>
    </div>

</div>
